import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter } from "@angular/core";
import { EventService } from "Services/event.service";
import { FetchDataService } from "Services/fetch-data.service";
import { User } from "Classes/User";
declare var $: any;

@Component({
    selector: "account-info",
    template: require('./account-info.component.html'),
    styles: [require('./account-info.component.css')]
})

export class AccountInfoComponent implements OnInit, AfterViewInit {
    constructor(
        private fetchDataService: FetchDataService,
        private eventService: EventService
    ) {

    }

    @Input() accountInfo: boolean;
    @Output() accountInfoChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    editSvg: string = "./assets/edit.svg";
    noEditSvg: string = "./assets/noEdit.svg";
    headerText: string = "Account Information";
    editing: boolean = false;
    errorText: string = "";

    permissionLookup: any = {};
    changePasswordData: any = {};
    changePasswordFlag: boolean = false;

    userData: any;
    localUserData: any = {};

    ngOnInit(): void {
        //this.userData = this.fetchDataService.getAuthData();
        this.permissionLookup[this.fetchDataService.admin] = "Admin";
        this.permissionLookup[this.fetchDataService.regular] = "Regular";
        this.userData = this.fetchDataService.getAuthData();
        $.extend(this.localUserData, this.userData);
    }

    ngAfterViewInit(): void {
        var inputs = $(".account-info-window-background").find('select, input, textarea, button, a').filter(':visible');
        var firstInput = inputs.first();
        var lastInput = inputs.last();

        /*set focus on first input*/
        $(inputs[1]).focus();

        /*redirect last tab to first input*/
        lastInput.on('keydown', function (e) {
            if ((e.which === 9 && !e.shiftKey)) {
                e.preventDefault();
                firstInput.focus();
            }
        });

        /*redirect first shift+tab to last input*/
        firstInput.on('keydown', function (e) {
            if ((e.which === 9 && e.shiftKey)) {
                e.preventDefault();
                lastInput.focus();
            }
        });
    }

    close(): void {
        this.accountInfo = false;
        this.accountInfoChange.emit(this.accountInfo);
    }

    switch(): void {
        this.changePasswordData = {};
        this.editing = !this.editing;
        this.errorText = "";
        if (this.editing && !this.changePasswordFlag) {
            $.extend(this.localUserData, this.userData);
            this.headerText = "Edit Information";
        } else if (this.editing && this.changePasswordFlag) {
            $.extend(this.localUserData, this.userData);
            this.headerText = "Change Password";
        } else {
            this.changePasswordFlag = false;
            this.headerText = "Account Information";
        }
        setTimeout(() => {
            var inputs = $(".account-info-window-background").find('select, input, textarea, button, a').filter(':visible');
            var firstInput = inputs.first();
            var lastInput = inputs.last();

            /*set focus on first input*/
            firstInput.focus();

            /*redirect last tab to first input*/
            lastInput.on('keydown', function (e) {
                if ((e.which === 9 && !e.shiftKey)) {
                    e.preventDefault();
                    firstInput.focus();
                }
            });

            /*redirect first shift+tab to last input*/
            firstInput.on('keydown', function (e) {
                if ((e.which === 9 && e.shiftKey)) {
                    e.preventDefault();
                    lastInput.focus();
                }
            });
        }, 0);
    }

    checkConfirmPassword(): string {
        if (this.changePasswordData.confirm) {
            if (this.changePasswordData.new === this.changePasswordData.confirm) {
                this.errorText = "";
                return "correct-password";
            } else {
                return "incorrect-password";
            }
        } else
            return "";
    }

    submitChanges(): void {
        let ref = this;
        if (!this.changePasswordFlag) {
            this.eventService.broadcast(this.eventService._showSpinner, "Submitting changes...");
            this.fetchDataService.updateUserInfo(this.localUserData).subscribe(
                (data) => {
                    ref.eventService.broadcast(ref.eventService._closeSpinner);

                    for (let key in ref.userData) {
                        ref.userData[key] = ref.localUserData[key];
                    }
                    ref.switch();
                }, (error) => {
                    ref.eventService.broadcast(ref.eventService._closeSpinner);
                    ref.errorText = "Submit Failed!";
                    console.error(error);
                });
        } else {
            if (this.changePasswordData.current && this.changePasswordData.new && this.changePasswordData.confirm) {
                if (this.changePasswordData.new === this.changePasswordData.confirm) {
                    this.eventService.broadcast(this.eventService._showSpinner, "Submitting changes...");
                    this.fetchDataService.changePassword({
                        password: this.changePasswordData.current,
                        newPassword: this.changePasswordData.new,
                        email: this.userData.email
                    }).subscribe(
                        (data) => {
                            ref.eventService.broadcast(ref.eventService._closeSpinner);
                            ref.switch();
                        }, (error) => {
                            ref.eventService.broadcast(ref.eventService._closeSpinner);
                            ref.errorText = "Submit Failed!";
                            console.error(error);
                        });
            } else {
                    this.errorText = "Confirm password doesn't match new password.";
                }
            } else {
                this.errorText = "Please fill out all fields.";
            }
        }
    }

    changePassword(): void {
        this.editing = true;
        this.changePasswordFlag = true;
        this.errorText = "";
        if (!this.changePasswordFlag) {
            this.headerText = "Edit Information";
            this.changePasswordData = {};
        }
        else if (this.editing)
            this.headerText = "Change Password";
        setTimeout(() => {
            var inputs = $(".account-info-window-background").find('select, input, textarea, button, a').filter(':visible');
            var firstInput = inputs.first();
            var lastInput = inputs.last();

            /*set focus on first input*/
            firstInput.focus();

            /*redirect last tab to first input*/
            lastInput.on('keydown', function (e) {
                if ((e.which === 9 && !e.shiftKey)) {
                    e.preventDefault();
                    firstInput.focus();
                }
            });

            /*redirect first shift+tab to last input*/
            firstInput.on('keydown', function (e) {
                if ((e.which === 9 && e.shiftKey)) {
                    e.preventDefault();
                    lastInput.focus();
                }
            });
        }, 0);
    }

    upperCase(str: string): string {
        if (str)
            if (str.charAt(0))
                return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
            else
                return str;
        else
            return "";
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./App/Components/account-info.component.ts